import { GridRowSelectionModel, GridValidRowModel } from '@mui/x-data-grid'
import { useCallback, useMemo, useState } from 'react'
import { mapToObj } from 'remeda'
import { useExport } from '~/features/import-export/useExport'

export const useDataGridProps = <T extends GridValidRowModel>({ rows }: { rows: T[] }) => {
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>([])

  const selectedRows = useMemo<T[]>(() => {
    const rowMap = mapToObj(rows, (r) => [r.id, r])
    return selectionModel.flatMap((s) => rowMap[s] ?? [])
  }, [rows, selectionModel])

  const onRowSelectionModelChange = useCallback(
    (newModel: GridRowSelectionModel) => setSelectionModel(newModel),
    []
  )
  const { handleExport } = useExport()
  const exportDatagrid = useCallback(() => handleExport(selectedRows), [handleExport, selectedRows])

  const reset = useCallback(() => setSelectionModel([]), [])

  return {
    selectedRows,
    exportDatagrid,
    reset,
    onRowSelectionModelChange,
    selectionModel,
  }
}
